import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el Ultrapack después de comprar?',
    a: 'Inmediatamente después del pago recibís un email con el link de descarga. En menos de 5 minutos tenés todo el material en tu dispositivo, listo para usar desde hoy mismo.'
  }, {
    q: '¿Es editable? ¿Puedo modificarlo?',
    a: 'El material está en formato PDF. Podés imprimir las hojas de trabajo y adaptarlas a cada paciente. Los protocolos y guiones son modelos base que ajustás a tu estilo y a cada caso clínico.'
  }, {
    q: '¿Sirve para todos los perfiles clínicos?',
    a: 'Sí. El Ultrapack cubre Dislexia, TDAH, Discalculia, TEA de alto rendimiento, dificultades emocionales, adolescentes en secundaria y orientación vocacional. El Tomo 1 te orienta exactamente a qué Tomo ir según el perfil de cada paciente.'
  }, {
    q: '¿Los 6 bonos están en las dos ofertas?',
    a: 'Sí. Los 6 bonos estratégicos están incluidos en ambas opciones sin costo adicional. No importa cuál elijas, los bonos siempre vienen incluidos.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-10 px-4 bg-dark-card/30 pt-[15px] pb-[15px]" data-id="element-123">
      <div className="max-w-2xl mx-auto" data-id="element-124">
        <h2 className="text-2xl md:text-3xl font-black text-center mb-6" data-id="element-125">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-126">
          {faqs.map((faq, i) => <div key={i} className="bg-dark border border-dark-border rounded-xl overflow-hidden" data-id="element-127">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-4 text-left focus:outline-none" data-id="element-128">
                <span className="font-bold text-sm" data-id="element-129">{faq.q}</span>
                <ChevronDown className={`w-4 h-4 text-brand transition-transform duration-300 flex-shrink-0 ml-2 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-130" />
              </button>
              <AnimatePresence data-id="element-131">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-132">
                    <div className="px-4 pb-4 text-gray-400 text-sm border-t border-dark-border/50" data-id="element-133">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}